import React from 'react';
import { InputError } from './ErrorInputStyled';

export const ErrorInput = ({ errorText, marginBottom }) => errorText
  ? <InputError marginBottom={marginBottom}>{errorText}</InputError>
  : null

export default ErrorInput;
